module.exports = __webpack_public_path__ + "img/12-01_Directing People.955efe13.svg";